import { Field } from 'redux-form';
import GridFieldComponent from './GridField';

const GridField = (props) => {
  return <Field name={props.name} component={GridFieldComponent} {...props} />;
}

export default GridField;
